<template>
    <div class="columns is-multiline is-gapless">
        <div class="column is-3" v-for="photo in photos" :key="photo.id">
            <PhotoQuestionImage :photo="photo" />
        </div>
    </div>
</template>

<script>
import PhotoQuestionImage from "./PhotoQuestionImage.vue";

export default {
    name: "photo-question",
    components: {
        PhotoQuestionImage,
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        photos() {
            return this.question.answer;
        },
    },
};
</script>